import styled from 'styled-components';

// Components
import GenericChips from '../../../../components/common/GenericChip';
import { Text } from '../../../../components/common/Texts';

// Material UI
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Card from '@mui/material/Card';

const CardCorrectTask = (props) => {
    const {
        formatDate,
        correctionDate,
        correctionWithCheck,
        check,
        setCheck,
        correctedSubmission,
        isEdit,
        note,
        redo,
        handleNote,
        handleRedo,
        handleToggleEdit,
        old,
        order,
        isCorrectionSaving = false,
    } = props;

    return (
        <WrapperCardRedo>
            <CardCorrection old={old}>
                <CardHeader>
                    <HeaderInfo>
                        <GenericChips
                            radius="5px"
                            textColor={old ? '#B31D15' : '#C29F43'}
                            fontSize="14px"
                            fontWeight="bold"
                            color={old ? '#FCE9E8' : '#F9F5EC'}
                            padding="15px 8px"
                            title={`${order}° Entrega`}
                        />
                        {!old && correctedSubmission && (
                            <HeaderActions>
                                <EditButton
                                    type="button"
                                    onClick={handleToggleEdit}
                                    disabled={isCorrectionSaving}
                                >
                                    {isEdit
                                        ? correctedSubmission
                                            ? 'Cerrar edición'
                                            : 'Cancelar corrección'
                                        : correctedSubmission
                                          ? 'Editar corrección'
                                          : 'Corregir entrega'}
                                </EditButton>
                            </HeaderActions>
                        )}
                        <Text fontWeight="bold" fontSize="14px">
                            {!!formatDate && `Entregado el${' '}${formatDate}`}
                        </Text>
                    </HeaderInfo>
                </CardHeader>
                <CardBody>
                    {correctionWithCheck ? (
                        <Flex>
                            <FormControlLabelFake
                                checked={check}
                                disabled={!isEdit}
                                onChange={() => setCheck(!check)}
                                control={
                                    <Checkbox
                                        disabled={!isEdit}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 32,
                                            },
                                        }}
                                    />
                                }
                                label="Entrega revisada"
                            />
                        </Flex>
                    ) : (
                        <Flex>
                            {!old ? (
                                <>
                                    {correctedSubmission ? (
                                        <TextFieldFake
                                            value={note}
                                            type="number"
                                            disabled={redo || !isEdit}
                                            onChange={handleNote}
                                        />
                                    ) : (
                                        <TextFieldFake
                                            value={note}
                                            type="number"
                                            disabled={redo || !isEdit}
                                            onChange={handleNote}
                                        />
                                    )}
                                </>
                            ) : (
                                <Text
                                    fontSize="20px"
                                    color="#000"
                                    fontWeight="bold"
                                >
                                    {note}
                                </Text>
                            )}
                            <Text
                                fontSize="20px"
                                color="#aaa"
                                fontWeight="bold"
                            >
                                /100
                            </Text>
                        </Flex>
                    )}
                </CardBody>
                {correctedSubmission && correctionDate !== 'Invalid date' && (
                    <MetaFooter>
                        <Text fontWeight="bold" fontSize="14px">
                            Corregido el {correctionDate}
                        </Text>
                    </MetaFooter>
                )}
            </CardCorrection>
            {!correctionWithCheck && !old && (
                <FormControlLabelFake
                    checked={redo}
                    disabled={!isEdit}
                    onChange={handleRedo}
                    control={<Checkbox size="small" disabled={!isEdit} />}
                    label="¿Rehacer actividad?"
                />
            )}
        </WrapperCardRedo>
    );
};

export default CardCorrectTask;

const WrapperCardRedo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;

    :after {
        content: '';
        position: absolute;
        height: 1px;
        bottom: 0;
        width: calc(100% + 3rem);
        left: -1.5rem;
        background-color: #f1f1f1;
    }
`;

const CardCorrection = styled(Card)`
    margin: 16px 0 0 0;
    padding: 1rem;
    min-height: 100px;
    border-radius: 12px;
    background-color: #f7f7f7;
    box-shadow: none;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 1.5rem;
    gap: 0.8rem;

    ::before {
        content: '';
        width: 12px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: ${(props) => (props.old ? '#B31D15' : '#C29F43')};
    }
`;

const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const HeaderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
`;

const EditButton = styled.button`
    background-color: #b31d15;
    color: #fff;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

const CardBody = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
`;

const Flex = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 18px;
    align-items: center;
`;

const FormControlLabelFake = styled(FormControlLabel)`
    margin-left: 1px;

    .MuiTypography-root {
        font-size: 14px;
        font-weight: 700;
        color: #222;
    }
`;

const MetaFooter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const TextFieldFake = styled(TextField)`
    width: 60px;
    background-color: #ffffff00;
    fieldset {
        border: 2px solid #ffffff00;
    }
    input {
        ::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
            -webkit-appearance: none !important;
            margin: 0;
        }
    }
    :focus {
        input {
            border-width: 0px !important;
            border: none !important;
        }
    }
`;
